export const FORM_REQUEST_TIMEOUT_MS = 20000;
export const NO_CONNECTION_TEXT = 'Нет связи с сайтом. Проверьте интернет и попробуйте ещё раз';

/**
 * POST формы с таймаутом (T-17b). Ответ, который не JSON, превращается в {status: 'error', message: ''};
 * сетевой сбой и таймаут — reject (вызывающий показывает NO_CONNECTION_TEXT).
 * @return {Promise<Object>} ответ API {status, message, ...}
 */
export function postForm(url, formData, timeoutMs = FORM_REQUEST_TIMEOUT_MS) {
    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const timer = controller ? setTimeout(() => controller.abort(), timeoutMs) : null;

    return fetch(url, {
        method: 'POST',
        body: formData,
        signal: controller ? controller.signal : undefined,
    })
        .then((response) => response.json().catch(() => ({ status: 'error', message: '' })))
        .finally(() => clearTimeout(timer));
}
